/* =====================================================================
   LF FILM FEATURE — assets/lf-film-feature.js  (section: lf-film-feature)
   One instance per .lf-ff[data-ff]. No dependencies.
   * video src is only attached when the band nears the viewport
   * autoplay = the iPhone-proven pattern from Hot New Releases / Item Spotlight:
     muted as a PROPERTY, load() + play() retries on every load stage, a short
     poll while visible, never pause before the first successful play
   * chapters follow currentTime, click to seek; data-act on the root switches
     the ground from warm blush (act 1) to icy lilac (act 2)
   * the bloom is a blurred, BRIGHTENED muted copy of the film kept in sync
   ===================================================================== */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__lfff) return; root.__lfff = true;
    var v = root.querySelector('.lf-ff__video');
    var bloom = root.querySelector('.lf-ff__bloom video');
    var chaps = [].slice.call(root.querySelectorAll('.lf-ff__chap'));
    var capEl = root.querySelector('.lf-ff__caption p');
    var bar = root.querySelector('.lf-ff__progress b');
    var ticks = root.querySelector('.lf-ff__progress');
    var sound = root.querySelector('.lf-ff__sound');
    var actSwitch = parseFloat(root.getAttribute('data-act2') || '0');
    var starts = chaps.map(function (c) { return parseFloat(c.getAttribute('data-t')) || 0; });
    var cur = 0, started = false, tries = 0, visible = false, loaded = false;

    /* ---------- lazy attach ---------- */
    function attach() {
      if (loaded || !v) return; loaded = true;
      // phones get the light rendition (the 720p is 4.5 Mbps / ~16 MB and starts slowly on mobile) unless on fast 4G
      var small = window.matchMedia && window.matchMedia('(max-width: 980px)').matches;
      var c = navigator.connection || {}, fast = c.effectiveType === '4g' && !c.saveData && (c.downlink || 0) >= 8;
      var lite = v.getAttribute('data-src-small');
      v.src = (small && !fast && lite) ? lite : v.getAttribute('data-src');
      if (bloom && window.innerWidth > 980 && !reduce) bloom.src = bloom.getAttribute('data-src');
      v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute('muted', '');
      ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function (ev) { v.addEventListener(ev, attempt); });
      v.addEventListener('loadedmetadata', drawTicks);
      v.load(); attempt();
    }
    function attempt() {
      if (started || tries > 30 || !v) return; tries++;
      var p = v.play(); if (p && p.then) p.then(function () { started = true; }).catch(function () {});
    }
    var poll = null;
    function startPoll() {
      if (poll || started) return;
      poll = setInterval(function () { if (started || tries > 30) { clearInterval(poll); poll = null; return; } attempt(); }, 400);
      setTimeout(function () { if (poll) { clearInterval(poll); poll = null; } }, 10000);
    }
    if (v) {
      v.addEventListener('playing', function () { started = true; if (bloom && bloom.src) { var b = bloom.play(); if (b && b.catch) b.catch(function(){}); } });
      v.addEventListener('click', function () { if (v.paused) { tries = 0; attempt(); } });
      document.addEventListener('visibilitychange', function () { if (!document.hidden && visible) attempt(); });
      var gesture = function () { if (!started && loaded) { tries = 0; attempt(); }
        ['touchstart', 'click', 'keydown'].forEach(function (ev) { window.removeEventListener(ev, gesture); }); };
      ['touchstart', 'click', 'keydown'].forEach(function (ev) { window.addEventListener(ev, gesture, { passive: true }); });
    }

    /* ---------- visibility: lazy load, veil, pause off screen ---------- */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) attach(); }); }, { rootMargin: '700px 0px' }).observe(root);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) {
            root.classList.add('is-revealed');
            if (started) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { attempt(); startPoll(); }
          } else if (started) { try { v.pause(); if (bloom) bloom.pause(); } catch (err) {} }
        });
      }, { threshold: 0.28 }).observe(root.querySelector('.lf-ff__stage'));
    } else { attach(); root.classList.add('is-revealed'); }

    /* ---------- chapters + progress + act ---------- */
    function drawTicks() {
      if (!ticks || !v.duration) return;
      starts.forEach(function (t, i) { if (!i) return; var s = document.createElement('i'); s.style.left = (t / v.duration * 100) + '%'; ticks.appendChild(s); });
    }
    function setChapter(i) {
      if (i === cur) return; cur = i;
      chaps.forEach(function (c, k) { c.classList.toggle('is-on', k === i); if (k < i) c.style.setProperty('--p', 1); else if (k > i) c.style.setProperty('--p', 0); });
      if (capEl) {
        var txt = chaps[i] ? chaps[i].getAttribute('data-caption') : '';
        capEl.classList.add('is-out');
        setTimeout(function () { capEl.textContent = txt; capEl.classList.remove('is-out'); }, reduce ? 0 : 320);
      }
    }
    function tick() {
      if (v && v.duration) {
        var t = v.currentTime, i = 0;
        for (var k = 0; k < starts.length; k++) if (t >= starts[k]) i = k;
        setChapter(i);
        var end = i + 1 < starts.length ? starts[i + 1] : v.duration;
        if (chaps[i]) chaps[i].style.setProperty('--p', Math.min(1, (t - starts[i]) / Math.max(.1, end - starts[i])).toFixed(3));
        if (bar) bar.style.width = (t / v.duration * 100).toFixed(2) + '%';
        root.setAttribute('data-act', actSwitch && t >= actSwitch ? '2' : '1');
        if (bloom && bloom.src && !bloom.paused && Math.abs(bloom.currentTime - t) > .35) bloom.currentTime = t;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    chaps.forEach(function (c, k) {
      c.addEventListener('click', function () {
        attach(); if (!v) return;
        var go = function () { v.currentTime = starts[k] + .01; if (bloom && bloom.src) bloom.currentTime = v.currentTime; tries = 0; attempt(); };
        if (v.readyState >= 1) go(); else v.addEventListener('loadedmetadata', go, { once: true });
      });
    });

    /* ---------- sound: unmute AND restart, so the song lands from the top ---------- */
    if (sound && v) sound.addEventListener('click', function () {
      attach();
      if (v.muted) { v.muted = false; v.currentTime = 0; if (bloom && bloom.src) bloom.currentTime = 0; v.play(); sound.classList.add('is-on');
        sound.querySelector('span').textContent = sound.getAttribute('data-off'); }
      else { v.muted = true; sound.classList.remove('is-on'); sound.querySelector('span').textContent = sound.getAttribute('data-on'); }
    });

    /* ---------- petals ---------- */
    var cv = root.querySelector('.lf-ff__petals');
    if (cv && !reduce && cv.getContext) {
      var ctx = cv.getContext('2d'), W = 0, H = 0, dpr = Math.min(2, window.devicePixelRatio || 1), P = [];
      var cols = ['#ffb3c4', '#ffd6e0', '#ffffff', '#ff97ad', '#ffe9f0'];
      function size() { W = root.clientWidth; H = root.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      function spawn(y) { return { x: Math.random() * W, y: y == null ? -20 : y, r: 5 + Math.random() * 7, vy: .25 + Math.random() * .55,
        vx: -.2 + Math.random() * .5, a: Math.random() * 6.28, va: -.02 + Math.random() * .04, sw: Math.random() * 6.28,
        c: cols[(Math.random() * cols.length) | 0], o: .45 + Math.random() * .4 }; }
      size(); var n = W < 700 ? 12 : 26; for (var i = 0; i < n; i++) P.push(spawn(Math.random() * H));
      window.addEventListener('resize', size);
      (function loop() {
        if (visible) {
          ctx.clearRect(0, 0, W, H);
          P.forEach(function (p, i) {
            p.sw += .012; p.x += p.vx + Math.sin(p.sw) * .35; p.y += p.vy; p.a += p.va;
            if (p.y > H + 20 || p.x < -30 || p.x > W + 30) P[i] = spawn();
            ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.globalAlpha = p.o; ctx.fillStyle = p.c;
            ctx.beginPath(); ctx.moveTo(0, -p.r); ctx.bezierCurveTo(p.r * .9, -p.r * .6, p.r * .7, p.r * .7, 0, p.r);
            ctx.bezierCurveTo(-p.r * .7, p.r * .7, -p.r * .9, -p.r * .6, 0, -p.r); ctx.fill();
            ctx.restore();
          });
        }
        requestAnimationFrame(loop);
      })();
    }
  }

  function boot() { [].forEach.call(document.querySelectorAll('.lf-ff[data-ff]'), init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
